// This component is generated by svgr. DO NOT EDIT.
import { SVGProps } from 'react'
type Props = {
  size?: 'sm' | 'md' | 'lg' | (string & {}),
} & Omit<SVGProps<SVGSVGElement>, 'width' | 'height' | 'color'>
const SvgFiletypeJpg = ({ size = 'md', ...props }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={
      size === 'sm'
        ? '8px'
        : size === 'md'
        ? '16px'
        : size === 'lg'
        ? '24px'
        : size
    }
    height={
      size === 'sm'
        ? '8px'
        : size === 'md'
        ? '16px'
        : size === 'lg'
        ? '24px'
        : size
    }
    fill="none"
    viewBox="0 0 158 206"
    {...props}
  >
    <path
      fill="#999"
      d="M0 4a4 4 0 0 1 4-4h95.807c2.366 0 4.637.932 6.322 2.595l33.193 32.762A9 9 0 0 1 142 41.762V183a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4z"
    />
    <path
      fill="#fff"
      d="M4 6a2 2 0 0 1 2-2h92a2 2 0 0 1 2 2v26.5c0 5.523 4.477 10 10 10h26a2 2 0 0 1 2 2V181a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2z"
    />
    <path
      fill="#999"
      d="M92.318 128H49.529c-4.189-.005-7.093-.806-10.055-3.768s-4.875-6.977-4.88-11.165V70.284c.005-4.188 1.363-7.647 4.325-10.608s6.422-4.32 10.61-4.325h42.789c4.188.005 7.64 1.363 10.601 4.325 2.96 2.962 4.321 6.42 4.324 10.608v42.783c-.003 4.187-1.364 7.647-4.324 10.609s-6.413 4.319-10.601 4.324M49.529 61.47a8.826 8.826 0 0 0-8.815 8.814v42.783a8.825 8.825 0 0 0 8.815 8.814h42.789a8.81 8.81 0 0 0 8.805-8.814V70.284a8.813 8.813 0 0 0-8.805-8.814z"
    />
    <path
      fill="#999"
      d="M104.62 104.931v8.136a12.312 12.312 0 0 1-12.302 12.301H49.529a12.304 12.304 0 0 1-12.302-12.301V99.41c6.848-1.473 17.281-1.937 29.943 3.119l7.846-7.478 5.347 13.56s1.434-4.988 6.065-4.281c4.63.707 12.128 3.216 15.335 1.075a4.12 4.12 0 0 1 2.857-.474M89.634 79.02a4.756 4.756 0 1 0 .001-9.512 4.756 4.756 0 0 0 0 9.513M22 166a4 4 0 0 1 4-4h128a4 4 0 0 1 4 4v36a4 4 0 0 1-4 4H26a4 4 0 0 1-4-4z"
    />
    <path
      fill="#fff"
      d="M119.135 186.833h-1.349c-1.349 0-1.878.027-2.671.133v-3.994c.979.132 1.561.158 3.306.158h1.746c1.27 0 2.195-.026 3.28-.132-.132 1.005-.185 1.825-.185 3.439v2.883c0 1.719.026 2.486.185 3.65-1.746 1.058-2.778 1.507-4.285 1.904-1.27.344-2.83.556-4.232.556-3.412 0-6.163-1.111-7.935-3.174-1.614-1.931-2.539-4.92-2.539-8.173 0-4.497 1.851-8.068 5.078-9.84 1.481-.846 3.306-1.243 5.475-1.243 2.672 0 4.973.873 6.56 2.46.899.926 1.375 1.719 1.931 3.253l-4.47 1.111c-.424-1.217-.82-1.798-1.587-2.301-.741-.503-1.614-.714-2.857-.714-1.455 0-2.804.529-3.73 1.481-1.216 1.27-1.851 3.227-1.851 5.819 0 2.539.608 4.576 1.746 5.872.952 1.084 2.38 1.64 4.232 1.64 1.587 0 2.83-.318 4.152-1.085zM89.106 194.98h-4.761c.158-1.084.211-2.142.211-3.65v-14.31c0-1.349-.053-2.354-.211-3.623 1.19.053 2.063.079 3.623.079h5.634c2.672 0 4.629.661 5.951 1.984 1.111 1.111 1.72 2.777 1.72 4.761 0 2.116-.635 3.862-1.878 5.105-1.35 1.375-3.306 2.036-5.872 2.036h-4.629v3.915c0 1.508.053 2.645.212 3.703m-.212-11.347h4.523c2.143 0 3.36-1.19 3.36-3.28 0-.952-.265-1.746-.794-2.275-.556-.608-1.376-.872-2.566-.872h-4.523zM74.619 173.476h4.866c-.158 1.085-.211 1.878-.211 3.65v11.612c0 2.089-.503 3.571-1.587 4.708-1.296 1.296-3.227 1.984-5.66 1.984q-3.85 0-5.873-2.222c-.687-.767-1.057-1.402-1.613-2.777l4.258-1.508c.397 1.243.741 1.799 1.402 2.222.45.317 1.164.502 1.878.502.9 0 1.72-.291 2.143-.767.423-.449.608-1.137.608-2.142v-11.585c0-1.773-.053-2.566-.212-3.677M57 190.404h4.576v4.576H57z"
    />
  </svg>
)
export default SvgFiletypeJpg
